module.exports = __webpack_public_path__ + "static/media/dk-logobar-web-dark-bkg.67c6e177.png";